import React from 'react';
import { ChevronLeft } from 'shared/assets/icons';
import { Collapse } from 'shared/components/ui/collapse';
import {
  Colors,
  IconButton,
  Sizes as IconButtonSizes,
} from 'shared/components/ui/icon-button';
import { useToggle } from 'shared/hooks/use-toggle';
import { ID } from 'shared/types/id';
import { TaskPriorityOptions } from 'shared/types/task-base';

import { GoalHeader } from './goal-header';
import { LifeAreaHeader } from './life-area-header';
import { PriorityHeader } from './priority-header';
import * as Styled from './section-layout.style';

export type SectionLayoutProps = {
  goalId?: ID;
  lifeAreaId?: ID;
  priority?: TaskPriorityOptions;
  onToggleCollapse?: (newState: boolean) => void;
  children: React.ReactNode;
};

export const SectionLayout: React.FC<SectionLayoutProps> = ({
  goalId,
  lifeAreaId,
  priority,
  onToggleCollapse,
  children,
}) => {
  const [collapseOpen, toggleCollapse] = useToggle(true);

  const _toggleCollapse = () => {
    toggleCollapse();
    onToggleCollapse?.(!collapseOpen);
  };

  return (
    <>
      <Styled.HeaderContainer onClick={_toggleCollapse}>
        {!!goalId && <GoalHeader goalId={goalId} />}
        {!!lifeAreaId && <LifeAreaHeader lifeAreaId={lifeAreaId} />}
        {!!priority && <PriorityHeader priority={priority} />}
        <Styled.IconButtonContainer>
          <IconButton
            icon={ChevronLeft}
            rotation={collapseOpen ? -90 : 0}
            size={IconButtonSizes.Small}
            color={Colors.Default}
            as="span"
          />
        </Styled.IconButtonContainer>
      </Styled.HeaderContainer>

      <Collapse isOpen={collapseOpen}>
        <Styled.ChildrenContainer>{children}</Styled.ChildrenContainer>
      </Collapse>
    </>
  );
};
